// src/pages/ContactPage.tsx
import React, { Suspense, useState } from 'react';
import api from '../services/api';
import { useNotification } from '../context/NotificationContext';
import { useTranslation } from 'react-i18next';

const ContactPageContent: React.FC = () => {
    const { showNotification } = useNotification();
    const { t } = useTranslation();

    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!subject.trim() || !message.trim()) {
            showNotification(t('contact.fillRequired'), 'error');
            return;
        }
        setSubmitting(true);
        try {
            await api.post('/Contact', { subject, message });
            showNotification(t('contact.success'), 'success');
            setSubject('');
            setMessage('');
        } catch (err: any) {
            const msg =
                err?.response?.data?.title ||
                err?.response?.data ||
                t('contact.error');
            showNotification(msg, 'error');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="max-w-2xl mx-auto bg-gray-800 p-8 rounded-lg shadow-lg">
            <h1 className="text-3xl font-bold text-white text-center mb-6">
                {t('contact.title')}
            </h1>

            <p className="text-gray-300 text-center mb-6">
                {t('contact.intro')}{' '}
                <span className="font-semibold">mail@thescoreboard.online</span>.
            </p>

            <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-300">
                        {t('contact.subject')}
                    </label>
                    <input
                        id="subject"
                        type="text"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        className="mt-1 block w-full bg-gray-700 border border-gray-600 rounded-md shadow-sm py-2 px-3 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                        placeholder={t('contact.placeholderSubject')}
                    />
                </div>

                <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-300">
                        {t('contact.message')}
                    </label>
                    <textarea
                        id="message"
                        rows={8}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        className="mt-1 block w-full bg-gray-700 border border-gray-600 rounded-md shadow-sm py-2 px-3 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                        placeholder={t('contact.placeholderMessage')}
                    />
                </div>

                <button
                    type="submit"
                    disabled={submitting}
                    className="w-full flex justify-center py-3 px-4 rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                >
                    {submitting ? t('contact.sending') : t('contact.send')}
                </button>
            </form>
        </div>
    );
};

const ContactPage = () => (
    <Suspense fallback={<div className="text-center p-8 text-white">{/* można też t('common.loading') */}Ładowanie…</div>}>
        <ContactPageContent />
    </Suspense>
);

export default ContactPage;
